/* eslint-disable jira/naming/disallow-filenames */
import { devOpsReportPreconditionResource } from '@jira/router-resources__devops-report-group/src/devOpsReportPreconditionResource.tsx';
import { staticSidebarJSWReportsResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/sidebar/static-jsw-reports-sidebar/index.tsx';
import { staticProjectReportsSidebarConnectAddonsNavigationResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/sidebar/static-project-sidebar-reports-connect-addons/index.tsx';
import type { JiraSoftwareReport } from '@atlassian/jira-navigation-apps-resources/src/services/sidebar/jsw-reports-sidebar-navigation/types.tsx';
import type { ProjectSidebarAddonNavItem } from '@atlassian/jira-navigation-apps-resources/src/services/sidebar/project-sidebar-connect-addons-navigation/types.tsx';
import type { RouteResource } from '@atlassian/react-resource-router';
import type { PreconditionResult } from '@jira/router-resources__devops-report-group/src/PreconditionResult.types.tsx';

export const getReportsCommonResource = (): (
	| RouteResource<PreconditionResult>
	| RouteResource<ProjectSidebarAddonNavItem[] | null>
)[] => [
	devOpsReportPreconditionResource,
	staticProjectReportsSidebarConnectAddonsNavigationResource,
];

export const getTMPReportsCommonResource = (): (
	| RouteResource<PreconditionResult>
	| RouteResource<ProjectSidebarAddonNavItem[] | null>
	| RouteResource<JiraSoftwareReport[] | null>
)[] => [
	devOpsReportPreconditionResource,
	staticProjectReportsSidebarConnectAddonsNavigationResource,
	staticSidebarJSWReportsResource,
];
